import { render, staticRenderFns } from "./Lights.vue?vue&type=template&id=68a61d95&scoped=true&"
import script from "./Lights.vue?vue&type=script&lang=js&"
export * from "./Lights.vue?vue&type=script&lang=js&"
import style0 from "./Lights.vue?vue&type=style&index=0&id=68a61d95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a61d95",
  null
  
)

export default component.exports